export default __webpack_public_path__ + "19dd64f4ec3cd680c4d70818f51f676b.png";